import { FC } from 'react';

const LeaderBoardEmptyState: FC<{ label: string }> = ({ label }) => (
  <div className="leader-board-empty-state">
    <span>{label}</span>
  </div>
);

export default LeaderBoardEmptyState;
